import qs from 'qs';

const isFromExtendedNetwork = (queryString = window.location.search) => {
  const extendedNetworkConstants = [
    'facebook_EN',
    'Google_EN',
    'DVC_EN_01',
    'DVC_EN_02',
    'DVC_EN_05',
  ];
  const { utm_source: utmSource } = qs.parse(queryString, { ignoreQueryPrefix: true });
  return extendedNetworkConstants.includes(utmSource);
};

export default isFromExtendedNetwork;
